import type { BlockPlugin } from "./types";

/**
 * Registro de tipos de bloque. El motor consulta AQUÍ el plugin de cada
 * `type`; añadir un tipo nuevo es `registry.register(plugin)`, sin tocar el
 * motor. Es la pieza que hace la plataforma genérica ("aprender cualquier cosa").
 */
export class BlockRegistry {
  private readonly plugins = new Map<string, BlockPlugin>();

  /** Registra un plugin. Lanza si el `type` ya existe (evita pisar tipos). */
  register(plugin: BlockPlugin): this {
    if (this.plugins.has(plugin.type)) {
      throw new Error(`BlockRegistry: tipo duplicado "${plugin.type}"`);
    }
    this.plugins.set(plugin.type, plugin);
    return this;
  }

  /** Registra varios de una vez. */
  registerAll(plugins: readonly BlockPlugin[]): this {
    for (const p of plugins) {
      this.register(p);
    }
    return this;
  }

  get(type: string): BlockPlugin | undefined {
    return this.plugins.get(type);
  }

  has(type: string): boolean {
    return this.plugins.has(type);
  }

  /** Lista de tipos registrados (para el editor de autoría: "insertar bloque"). */
  types(): string[] {
    return [...this.plugins.keys()];
  }
}
